import { tv } from "tailwind-variants";

export const contentResultListHit = tv({
    base: [
        "tw:p-4 tw:border tw:border-tertiary tw:rounded-xl tw:transition-colors",
        "tw:hover:border tw:hover:border-primary"
    ]
});
